export default __webpack_public_path__ + "static/og-image-588841b02369e24f54ff70e87b261ebb.png";